export const WEB_API_ENDPOINT = "web-api";
export const GROUP_BUCKET = "GROUP_BUCKET";
export const MESSAGE_BUCKET = "MESSAGE_BUCKET";

const awsAmplify = {
  WEB_API_ENDPOINT,
  GROUP_BUCKET,
  MESSAGE_BUCKET,
};

export default awsAmplify;
